import "./Loader.scss"

const Loader = () => {
    return <div className="Wrapper">
        <div className="Loader">
            <div />
            <div />
            <div />
            <div />
        </div>
    </div>
}

export default Loader